import { Combobox } from '@consta/uikit/Combobox'
import type { FC } from 'react'

import css from './AddingFilesModal.css'
import type { CoordinatesType, CoordsTemplate } from './types'

type MasterImportProps = {
  coordProps: CoordinatesType
  coordValue?: CoordsTemplate
  setHeaderCoordsValue: (headerCoords: CoordsTemplate) => void
}

export const AddingFilesModalCoordinatesFields: FC<MasterImportProps> = ({
  coordProps,
  coordValue,
  setHeaderCoordsValue,
}) => {
  const { name, values, coordName } = coordProps
  const comboValue = coordValue?.[coordName]?.toString()

  const setComboboxValue = (value: { label: string } | null) => {
    const offset = value ? parseInt(value.label, 10) : NaN
    const newValue: CoordsTemplate = {
      ...coordValue,
      [coordName]: isNaN(offset) ? undefined : offset,
    }
    setHeaderCoordsValue(newValue)
  }

  return (
    <div className={css.coordinatesComboboxWrapper}>
      <Combobox
        name={name}
        dropdownClassName={css.coordinatesComboboxDropdown}
        size="s"
        items={values}
        label={name}
        required={true}
        value={values.find(value => value.label === comboValue)}
        getItemKey={value => value.label}
        status={!comboValue ? 'alert' : undefined}
        onChange={setComboboxValue}
      />
    </div>
  )
}
